import React from "react";
import PropTypes from "prop-types";
import { useDispatch } from "react-redux";

import { IconButton } from "@material-ui/core";

import Icon from "components/Icon";
import ModalConfirm from "components/ModalConfirm";
import AuthWrapper from "components/AuthWrapper";

import { deleteShelf } from "store/warehouse/actions";

const DeleteShelf = ({ shelf }) => {
  const dispatch = useDispatch();

  const deleteThisRack = (event) => {
    event.stopPropagation();

    dispatch(deleteShelf(shelf._id));
  };

  return (
    <AuthWrapper permission={"LOCATIONS.LOCATIONS_UPDATE"}>
      <ModalConfirm
        modalTitle={`Delete shelf ${shelf.name}`}
        actionOnAccept={deleteThisRack}
        message={"Are you sure that you want to delete this shelf?"}
        Component={(props) => (
          <IconButton {...props}>
            <Icon name={"trash-can"} fontSize={13} />
          </IconButton>
        )}
        actionOnAcceptText={"Delete shelf"}
      />
    </AuthWrapper>
  );
};

DeleteShelf.propTypes = {
  shelf: PropTypes.object.isRequired,
};

export default DeleteShelf;
